import { shellStringResources } from '../../Resources/ShellStringResources';
import { IModel } from '../base/annotation';
import { Metamodel } from '../base/model';
import { ExpressCustomSetup, expressCustomSetupTypes } from './expressCustomSetup';

export const authenticationLevels = {
    Matual: 'Matual',
    Incoming: 'Incoming',
    NoAuth: 'NoAuth'
};

@Metamodel.model({
    name: 'MsdtcConfiguration',
    display: [shellStringResources.ModelName_MsdtcConfigurationExtension, shellStringResources.ModelName_MsdtcConfigurationExtensions]
})
export class MsdtcSetup extends ExpressCustomSetup {
    public static readonly MODEL: IModel;

    public allowRemoteClients: boolean = true;
    public allowRemoteAdmin: boolean = true;
    public allInbound: boolean = true;
    public allOutbound: boolean = true;
    public authenticationLevel: string = authenticationLevels.NoAuth;
    public enableXATransactions: boolean = true;
    public enableLUTransactions: boolean = true;

    constructor(name?: string, public description?: string) {
        super(expressCustomSetupTypes.Msdtc, name, description);
    }

    public getCustomSetupName(): string {
        return shellStringResources.IRCreation_SSIS_CustomSetup_MsdtcEnabled;
    }

    public coincideWith(customSetup: ExpressCustomSetup): void {
        if (this.customSetupType === customSetup.customSetupType) {
            const setup = customSetup as MsdtcSetup;
            this.allowRemoteClients = setup.allowRemoteClients;
            this.allowRemoteAdmin = setup.allowRemoteAdmin;
            this.allInbound = setup.allInbound;
            this.allOutbound = setup.allOutbound;
            this.authenticationLevel = setup.authenticationLevel;
            this.enableXATransactions = setup.enableXATransactions;
            this.enableLUTransactions = setup.enableLUTransactions;
        }
    }

    public validate(): boolean {
        return true;
    }
}
